/**
 * Created with IntelliJ IDEA.
 * User: sronge
 * Date: 25.06.13
 * Time: 14:46
 * To change this template use File | Settings | File Templates.
 */


import { IdentityManagementConstants } from "../constants/IdentityManagementConstants";

import TimerEvent = createjs.TimerEvent;
import TextField = createjs.Text;
import { Timer } from "@goodgamestudios/createjs-utilities";
import { Signal } from "signals.js";

export class ShutDownControlTimer {
    public static NAME: string = "ShutDownControlTimer";
    public static _secondsUntilShutDown: number;
    public shutDownTimer: Timer;

    //only for testing
    public shutDownTimerText: TextField = new TextField();

    public showCountDownTimer: Signal;
    public hideCountDownTimer: Signal;

    constructor(secondsUntilShutDown: number) {
        ShutDownControlTimer._secondsUntilShutDown = secondsUntilShutDown;

        this.initCountDownTimer();

        this.showCountDownTimer = new Signal();
        this.hideCountDownTimer = new Signal();
    }

    //init timer
    private initCountDownTimer(): void {
        this.shutDownTimer = new Timer(1000, ShutDownControlTimer._secondsUntilShutDown);
    }

    // start
    public startCountDown(): void {
        this.startShutDownTimer();
    }

    private startShutDownTimer(): void {
        this.shutDownTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.onShutDownTimer));
        this.shutDownTimer.start();
    }

    private onShutDownTimer(event: TimerEvent): void {
        this.showCountDownTimer.dispatch();
        this.hideCountDown();
    }

    private hideCountDown(): void {
        this.shutDownTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onShutDownTimerComplete));
    }

    private onShutDownTimerComplete(event: TimerEvent): void {
        this.hideCountDownTimer.dispatch();
    }

    public stopShutDownTimer(): void {
        //remove signal
        this.showCountDownTimer.removeAll();
        this.hideCountDownTimer.removeAll();

        //stop timer
        this.shutDownTimer.stop();

        //remove listener
        this.shutDownTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.onShutDownTimer));
        this.shutDownTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onShutDownTimerComplete));
    }

    //only for testing
    public get showTimerCountdown(): string {
        let minutes: number = Math.floor((IdentityManagementConstants.SHUTDOWN_CONTROL_TIMER - this.shutDownTimer.currentCount) / 60);
        let seconds: number = (IdentityManagementConstants.SHUTDOWN_CONTROL_TIMER - this.shutDownTimer.currentCount) % 60;
        seconds >= 10 ? this.shutDownTimerText.text = minutes + ":" + seconds : this.shutDownTimerText.text = minutes + ":0" + seconds;

        return this.shutDownTimerText.text.toString();
    }
}

